export const getBillingItems = [
  {
    label: 'Payments',
    navigate: '/myportal/billing',
    value: 'billing',
    type: null
  },
  {
    label: 'Superbills',
    navigate: '/myportal/billing/superbills',
    value: 'superbills',
    type: 'superbills'
  },
  {
    label: 'Quotes',
    navigate: '/myportal/billing/quotes',
    value: 'quotes',
    type: 'quotes'
  }
];
